import {
    BusinessDetails,
    ContactDetails,
    FooterLink,
    GoogleDetails,
    MetaTagsProps,
    SocialMediaProfilesTypes
} from "@/types";

export const BUSINESS_NAME: string = "Innovative Construct Group";
export const WEBSITE_URL: string = "https://ic-group.com.au";
export const OG_PATH = `${WEBSITE_URL}/images/og/`;
export const defaultMetaTags: MetaTagsProps = {
    title: `${BUSINESS_NAME} | Sydney Formwork, Concreting, Excavation, Steelfixing, and Structural Construction Specialists`,
    description: `${BUSINESS_NAME} are Sydney specialists in formwork, concreting, excavation, steelfixing, and structural construction. We deliver reliable, high-quality solutions for residential, commercial, and civil projects across New South Wales.`,
    keywords: "formwork Sydney, concreting Sydney, excavation Sydney, steelfixing Sydney, concrete pumping Sydney, structural construction Sydney, basement construction Sydney, slab formwork Sydney, retaining walls Sydney, commercial formwork Sydney",
    url: WEBSITE_URL,
    ogImage: `${OG_PATH}img1.jpg`,
    type: "website",
}

export const socialMediaProfiles: SocialMediaProfilesTypes = {
    instaLink: "https://www.instagram.com/",
    instaHandle: "innovativeconstructgroup",
    instaPostsLink: "https://www.instagram.com/p/",
    tikTokLink: "https://www.tiktok.com/",
    tikTokHandle: "",
    tikTokPostsLink: "https://www.tiktok.com/",
    facebookLink: "https://www.facebook.com/",
    facebookHandle: "",
    linkedInLink: "https://www.linkedin.com/company/",
    linkedInHandle: "",
    youTubeHandle: "",
    youTubeLink: "https://youtube.com/",
}

export const contactDetails: ContactDetails = {
    contactNumberOne: "0451 081 141",
    contactNumberTwo: "",
    fax:"",
    contactEmail: "ehab@ic-group.com.au",
}

export const footerLinks: FooterLink[] | undefined = undefined;

export const googleDetails: GoogleDetails = {
    googleHandle: "",
    googleLink: "",
    googleMaps: "",
    googleReviewLink: "",
    googleServiceArea: "", //embed link
    areaServed: "Sydney",
    serviceAreaLatLong: {
        latitude: -33.9180, // Sydney
        longitude: 151.0346
    }
}

export const businessDetails: BusinessDetails = {
    branding: {
        headerLogoUrl: "/images/logos/header-logo.svg",
        footerLogoUrl: "/images/logos/footer-logo.svg",
    },
    companyData: {
        abn: "",
        address: "",
        licenseNumber: "",
    },
    captchaKeys: {
        dev: "6LeDLn4UAAAAAPW2RFlXvgusfkU9e_n4Q7zFtpQj",
        prod: "6LcP3p0oAAAAAOLrgJTbudQ5pkckcNng9CJtxr1M",
    },
    address: {
        streetAddress: "123 High St",
        addressLocality: "Bankstown",
        addressRegion: "NSW",
        postalCode: "2200",
        addressCountry: "AU"
    },
    serviceAreas: [
        "Sydney CBD",
        "Inner West",
        "Eastern Suburbs",
        "Lower North Shore",
        "Upper North Shore",
        "Northern Beaches",
        "Western Sydney",
        "Southern Sydney",
        "Sutherland Shire",
        "Greater Western Sydney",
    ],
    generalServiceArea:'Sydney'
};
